<template>
    <div class="pageImgSet">
        <TopLogo></TopLogo>
        <el-button v-if="true" type="primary" @click="is_show_dialog=true">add item</el-button>
        <el-button type="primary" @click="$router.push('/admin/tendancesSet')">tendancesSet</el-button>
        <el-button type="primary" @click="$router.push('/admin/configSystemSet')">configSystemSet</el-button>
        <el-button type="primary" @click="$router.push('/admin/pageMetaSet')">pageMetaSet</el-button>
        <div v-for="(item,key) of list" :key="key">
            <h3 class="title">{{ key }}</h3>
            <div class="item">
                <div v-for="(childItem,childKey) of item" :key="childKey" class="childItem">
                    <div class="leftBox">
                        <span class="imgName">{{ childKey }}</span>
                        <p class="imgName">{{ childItem.type }}</p>
                        <div class="imgName">{{ childItem.width + '*' + childItem.height }}</div>
                    </div>
                    <div>
                        <el-upload
                            class="avatar-uploader"
                            :action="uploadUrl"
                            :show-file-list="false"
                            :on-success="(res,file)=>{handleAvatarSuccess(res,file,childItem)}"
                            :before-upload="(file)=>{beforeAvatarUpload(file,childItem)}">
                            <el-image v-if="childItem.file_url" :src="childItem.file_url" class="itemImg" fit="cover"/>
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <!--                    <el-button type="primary" @click="add_client_page_img(childItem)">change</el-button>-->
                    </div>
                </div>
            </div>

        </div>
        <el-dialog :visible.sync="is_show_dialog" class="dialog">
            <el-form label-position="right">
                <el-form-item label="page" class="formName">
                    <el-select v-model="formItem.page">
                        <el-option v-for="item of pages" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="client img name" class="formName">
                    <el-input v-model="formItem.client_img_name" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="img type" class="formName">
                    <el-select v-model="formItem.type">
                        <el-option v-for="item of types" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="img" class="formName">
                    <el-upload
                        class="avatar-uploader"
                        :action="uploadUrl"
                        :show-file-list="false"
                        :on-success="handleAddNewUploadSuccess"
                        :before-upload="beforeAvatarUpload">
                        <el-image v-if="formItem.file.file_url" :src="formItem.file.file_url" class="itemImg"
                                  fit="cover"/>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
            </el-form>
            <el-button type="primary" @click="add_client_page_img">submit</el-button>
        </el-dialog>
    </div>
</template>

<script>
import base from '@/api/base';
import TopLogo from "@/components/topLogo"; // 导入接口域名列表

export default {
    name: "PageImgSet",
    components: {TopLogo},
    data() {
        return {
            base: base,
            is_show_dialog: false,
            loading: false,
            uploadUrl: base.dev + '/v2/admin_config/upload_file',
            pages: ['home', 'homeLogin','topMenu'],
            types: ['web', 'mobile'],
            list: {},
            formItem: {
                page: '',
                id_file: '',
                client_img_name: '',
                type: 'web',
                file: {},
            },
        }
    },
    mounted() {
        this.initData();
    },
    methods: {
        initData() {
            this.$api.home.get_client_page_img_list().then(async res => {
                if (res.code == 0) {
                    this.list = res.data;

                    //循环设置图片像素大小
                    this.setImgWH();
                }
            })
        },
        handleAvatarSuccess(res, file, pageImgConfig) {
            if (res.code == 0) {
                let params = {
                    id_page_img_client_config: pageImgConfig.id_page_img_client_config,
                    id_file: res.data.id_file,
                }
                this.$api.home.update_client_page_img(params).then(res => {
                    if (res.code != 0) return this.$message.error(res.message);
                    this.$message.success(res.message);
                    this.initData();
                })
            } else this.$message.error(res.message);
        },
        async beforeAvatarUpload(file, childItem) {
            // const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 5;
            let fileWH = await this.getImgFileInfo(file);
            if (childItem) { //如果像素不一致，不允许上传
                if (fileWH.width != childItem.width || fileWH.height != childItem.height) this.$message.error('width or height is not match');
            }
            // if (!isJPG) {
            //     this.$message.error('上传头像图片只能是 JPG 格式!');
            // }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 5MB!');
            }
            return isLt2M;
        },
        handleAddNewUploadSuccess(res, file) {
            if (res.code == 0) {
                this.formItem.file = res.data;
                this.formItem.file.file_url = base.dev + this.formItem.file.file_url;
            }
        },
        add_client_page_img() {
            let params = {
                page: this.formItem.page,
                id_file: this.formItem.file.id_file,
                client_img_name: this.formItem.client_img_name,
                type: this.formItem.type
            };
            this.$api.home.add_client_page_img(params).then(res => {
                if (res.code == 0) {
                    this.$message.success(res.message);
                    this.initData();
                } else this.$message.error(res.message);
            })
        },
        getUrlInfo(item) {
            let img = new Image();
            item.width = 0;
            item.height = 0;
            let that = this;
            img.onload = function () {
                item.width = this.width;
                item.height = this.height;
                that.$forceUpdate();
            }
            img.src = item.file_url;
        },
        async getImgFileInfo(file) {
            return new Promise(resolve => {
                let img = new Image();
                let item = {};
                item.width = 0;
                item.height = 0;
                let _URL = window.URL || window.webkitURL;
                img.onload = function () {
                    item.width = this.width;
                    item.height = this.height;
                    resolve(item);
                }
                img.src = _URL.createObjectURL(file);
            })
        },
        setImgWH: function () {
            for (let item of Object.values(this.list)) {
                for (let childItem of Object.values(item)) {
                    this.getUrlInfo(childItem);
                }
            }
        }
    }
}
</script>

<style lang="less" scoped src="@/assets/viewCss/views/admin/PageImgSet.less">
</style>
